<template>
  <ul
    class="oct-card-list"
    :class="{
      'oct-card-list--dense': dense
    }"
  >
    <slot />
  </ul>
</template>

<script>
export default {
  name: 'OctCardList',
  props: {
    /** Dense */
    dense: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-card-list {
  margin: 0 -6px -48px;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  padding: 0;
  list-style: none;
  box-sizing: border-box;

  &--slider {
    margin: 0 -20px -48px;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-end;
    padding: 0 14px;
    overflow: auto;
  }

  &--dynamic {
    flex-direction: row;
    flex-wrap: wrap;
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin: 0 oct-rem(-12) oct-rem(-80);

  &--dense {
    margin-bottom: oct-rem(-48);
  }

  &--slider {
    margin: 0 -40px -80px;
    padding: 0 28px;
  }

  &--dynamic {
    justify-content: flex-end;
  }
}
}
</style>
